// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"33eb2ca6","897":"e8796154"}[chunkId] + ".chunk.js";
};